export default "__VITE_ASSET__Cxw5a_nx__"